























































































import Vue from "vue";
import FormDialog, { iFormDialogOptions } from "@/components/FormDialog.vue";
import { mapActions } from "vuex";

export default Vue.extend({
  name: "activity-log",
  data() {
    return {
      campaigns: null,
      searchDebounce: null,
      search: "",
      selected: [],
      selectedUser: "",
      loadDone: false,
      users: null,
      logs: null,
      page: 1,
      perPage: 50,
      limits: [10, 20, 50, 100, 200, 500, 1000],
      total: 0
    };
  },
  async created() {
    const res = await this.checkShowMenu(this.$route.fullPath);
    if (!res) this.$router.push({ name: "permissionDenied" });
    this.reload();
  },
  methods: {
    ...mapActions({ checkShowMenu: "menu/checkShowMenu" }),
    async reload(local = true) {
      try {
        this.loadDone = false;
        let tasks: any[] = [];
        tasks.push(
          this.$store
            .dispatch("user/getList", {
              local,
              query: {
                limit: 0,
                fields: "username _id role"
              }
            })
            .then(res => (this.users = res))
        );
        tasks.push(
          this.$store
            .dispatch("activityLog/getList", {
              local,
              query: {
                limit: this.perPage,
                filter: this.createFilter(),
                populates: ["user"],
                page: this.page
              }
            })
            .then(res => {
              this.logs = [...res.map((x, i) => ({ ...x, index: i }))];
            })
        );
        await Promise.all(tasks);
        console.log(this.logs);
        this.total = this.$store.getters["activityLog/total"];
      } catch (err) {
        this.$store.dispatch(
          "error/handleError",
          err,
          "Lấy lịch sử thao tác thất bại"
        );
      } finally {
        this.loadDone = true;
      }
    },
    createFilter() {
      let filter = {};
      if (this.selectedUser) filter["user"] = this.selectedUser;
      if (Object.keys(filter).length) return filter;
      return undefined;
    },
    searchChanged() {
      if (this.searchDebounce) clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => {
        this.filterChanged();
      }, 300);
    },
    filterChanged() {
      this.page = 1;
      this.reload();
    },
    onPageChange(page) {
      this.page = page;
      this.reload();
    }
  }
});
